export default function ClassicLoader() {
  return (
    <div className="h-10 w-10 animate-spin rounded-full border-4 border-gray-200 dark:border-gray-800 border-t-primary dark:border-t-accent" />
  )
}